// Thirdparty
import React, {useState, useEffect} from 'react';
// Styles
import './../styles/Account.css';
// Components
import UpdatePasswordModal from './../components/UpdatePasswordModal';
import UpdateMobileModal from './../components/UpdateMobileModal';
// Services
const Routes = require("./../services/routes.js");

async function fetchAccount(){
  try{
    const url = Routes.getAuthUserURL() + "/user";
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);
    
    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {"content-type": "application/json"},
        credentials: 'include',
      }
    );
    const result = await response.json();

    // Failure
    if(!response.ok){
      console.error(`Failed to fetch account: ${response.statusText} Status:${response.status}`);

      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
        return;
      }
    }
    // Redirect
    else if (result.redirect){
      window.location = result.url;
      return;
    }
    else if(typeof result.verified !== 'undefined'){
      localStorage.verified = result.verified;
    }
    
    // success
    return result;    
  }
  catch(err){
    console.error("Failed fetch account: ", err);
  }
}

function Account(){
  // States
  const [isPasswordOpen, setPasswordOpen] = useState(false);
  const [isMobileOpen, setMobileOpen] = useState(false);
  const [account, setAccount] = useState({});

  useEffect(() => {
    // Only need to fetch account if logged in!
    if (localStorage.verified===undefined){
      window.location = `/`; // redirect the page to the home page.
    }

    fetchAccount().then(accountInfo =>{
      if (accountInfo){
        setAccount(accountInfo);
      }
    });
  }, []);

  return (
    <div className="account-container">
      <div>
        <h2 style={{paddingTop:"30px", paddingLeft:"30px"}}>Account Assets</h2>

        <div className="account-list">

          <div className='row account-row'>
            <div className='column account-column'>
              <h3>Balance</h3>
            </div>

            <div className='column acount-column'>
              <p>{account.balance} BTC</p>
            </div>
          </div>

          <hr className="solid"/>

        </div>
      </div>

      <div>
        <h2 style={{paddingTop:"30px", paddingLeft:"30px"}}>Account Details</h2>

        <div className="account-list">

          <div className='row account-row'>
            <div className='column account-column'>
              <h3>Email</h3>
            </div>

            <div className='column acount-column'>
              <p>{account.email}</p>
            </div>

            <div className='column account-column'>
            {account.email===null?<p className='account-btn'>update</p>:<p/>}
            </div>
          </div>

          <hr className="solid"/>

          <div className='row account-row'>
            <div className='column account-column'>
              <h3>Mobile</h3>
            </div>

            <div className='column account-column'>
              <p>{account.mobile}</p>
            </div>

            <div className='column account-column'>
              {/* {account.mobile===null?<p className='account-btn' onClick={()=>{setMobileOpen(true)}}>update</p>:<p/>} */}
              <p className='account-btn' onClick={()=>{setMobileOpen(true)}}>update</p>
            </div>
          </div>

          <hr className="solid"/>

          <div className='row account-row'>
            <div className='column account-column'>
              <h3>Password</h3>
            </div>

            <div className='column account-column'>
              <p>********</p>
            </div>

            <div className='column account-column'>
              <p className='account-btn' onClick={()=>setPasswordOpen(true)}>update</p>
            </div>
          </div>

          <hr className="solid"/>

        </div>
      </div>

      <div>
        <h2 style={{paddingTop:"30px", paddingLeft:"30px"}}>Settings</h2>

        <div className="account-list">

          <div className='row account-row'>
            <div className='column account-column'>
              <h3>Notifications</h3>
            </div>

            <div className='column account-column'>
              <p>Email</p>
            </div>

            <div className='column account-column'>
              {/* <p className='account-btn'>update</p> */}
            </div>
          </div>

          <hr className="solid"/>

        </div>
      </div>

      {/* Modals */}
      <UpdatePasswordModal open={isPasswordOpen} onClose={()=>setPasswordOpen(false)}></UpdatePasswordModal>
      <UpdateMobileModal open={isMobileOpen} onClose={()=>setMobileOpen(false)}></UpdateMobileModal>
    </div>
  )
}

export default Account;
